import { Button, Grid } from '@mui/material';
import React from 'react'
import './scss/tab.component.scss'

export default function Tab(
    {
        data,
        activeIndex,
        containerStyle,
        itemStyle,
        onClick
    }: {
        data: { title: string | React.ReactNode }[],
        activeIndex: number,
        containerStyle?: React.CSSProperties,
        itemStyle?: React.CSSProperties,
        onClick: (index: number) => void,
    }) {
    return (
        <Grid className='tab-component'
            style={{ ...containerStyle }}
            container
            direction='row'
        // maxWidth={600}
        >
            {
                data.map((e, i) => (
                    <Grid item key={i}>
                        <Button
                            color='primary'
                            variant={activeIndex === i ? 'contained' : 'text'}
                            onClick={() => onClick(i)}
                            style={{ minWidth: 100, padding: '6px 16px', ...itemStyle }}
                        >
                            {e.title ?? ''}
                        </Button>
                    </Grid>
                ))
            }
        </Grid>
    )
}

